import {GetSeferData} from "SeferPetach/GetData";

async function call() {
    return (await GetSeferData("utl1", {}));
} 
function idFilter(obj) {
    return typeof obj?.StatusId === "number" && obj.StatusId <= 2;
}

export async function getSystemStatusList(obj) {
    try {
        const payload = await call();

        if (payload?.Status?.Code !== 0) {
            return [];
        }

        let vt = Array.isArray(payload?.Response?.Content?.StatusList)
            ? payload?.Response?.Content?.StatusList
            : [];

        if (obj.type === 1) {
            vt = vt.filter(idFilter);
        }

        return vt;

    } catch (error) {
        console.error(error);
        return [];
    }
}
